module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login_forget_register_box pull-right"
  }, [_c('section', {
    staticClass: "login_box switchover login_box_1"
  }, [_c('div', {
    staticClass: "box_info"
  }, [_c('div', {
    staticClass: "switchover_btn text-center h4",
    attrs: {
      "id": "cloudLogin"
    }
  }, [_vm._v("\n        登录\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "login_box_info"
  }, [_c('h5', {
    staticClass: "h4 login_title"
  }, [_vm._v("账户密码登录")]), _vm._v(" "), _c('div', {
    staticClass: "login_form_box"
  }, [_c('form', {
    attrs: {
      "action": "#",
      "method": ""
    }
  }, [_c('div', {
    staticClass: "user login_mbtm6"
  }, [_c('label', {
    staticClass: "label_focus",
    attrs: {
      "for": "login_user_name"
    }
  }, [_vm._v("手机号码")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    staticClass: "form-control input_focus login_form",
    attrs: {
      "type": "text",
      "id": "login_user_name"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.login.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "password login_mbtm6"
  }, [_c('label', {
    staticClass: "label_focus",
    attrs: {
      "for": "login_psw"
    }
  }, [_vm._v("密码")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control input_focus login_form",
    attrs: {
      "type": "password",
      "id": "login_psw"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.login.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "forget_yzm login_mbtm6"
  }, [_c('label', {
    staticClass: "label_focus",
    attrs: {
      "for": "forget_yzm"
    }
  }, [_vm._v("验证码")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.yanzm),
      expression: "yanzm"
    }],
    staticClass: "form-control inline-block input_focus login_form",
    attrs: {
      "type": "text",
      "id": "forget_yzm"
    },
    domProps: {
      "value": (_vm.yanzm)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.login.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.yanzm = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "yzm_box inline-block"
  }, [_c('img', {
    attrs: {
      "id": "verifyImg"
    },
    on: {
      "click": function($event) {
        return _vm.fleshVerify('verifyImg')
      }
    }
  })]), _vm._v(" "), _c('i', {
    staticClass: "glyphicon icon_reload",
    attrs: {
      "id": "cloudFreshenOne"
    },
    on: {
      "click": function($event) {
        return _vm.fleshVerify('verifyImg')
      }
    }
  })]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "login_btn_box text-center"
  }, [_c('a', {
    staticClass: "btn btn_h btn_issue",
    attrs: {
      "href": "javascript:void(0);",
      "id": "ypt_login"
    },
    on: {
      "click": function($event) {
        return _vm.login()
      }
    }
  }, [_vm._v("登录")])])])])])])]), _vm._v(" "), _c('section', {
    staticClass: "forget_box switchover login_box_2"
  }, [_c('div', {
    staticClass: "box_info"
  }, [_c('div', {
    staticClass: "switchover_btn text-center h4 switchover_btn1",
    attrs: {
      "id": "cloudForgetOne"
    },
    on: {
      "click": function($event) {
        return _vm.fleshVerify('verifyImg2')
      }
    }
  }, [_vm._v("\n        忘记密码\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "forget_box_info"
  }, [_c('h5', {
    staticClass: "h4 login_title"
  }, [_vm._v("找回密码")]), _vm._v(" "), _c('div', {
    staticClass: "forget_form_box"
  }, [_c('form', {
    attrs: {
      "action": "#",
      "method": ""
    }
  }, [_c('div', {
    staticClass: "forget_user login_mbtm6"
  }, [_c('label', {
    staticClass: "label_focus",
    attrs: {
      "for": "forget_user_name"
    }
  }, [_vm._v("手机号码")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.user.mobile),
      expression: "user.mobile",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control input_focus login_form",
    attrs: {
      "type": "text",
      "id": "forget_user_name"
    },
    domProps: {
      "value": (_vm.user.mobile)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.updatePassword.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "mobile", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "forget_yzm login_mbtm6"
  }, [_c('label', {
    staticClass: "label_focus",
    attrs: {
      "for": "forget_yzm1"
    }
  }, [_vm._v("验证码")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.user.yzm),
      expression: "user.yzm",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control inline-block input_focus login_form",
    attrs: {
      "type": "text",
      "id": "forget_yzm1"
    },
    domProps: {
      "value": (_vm.user.yzm)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.updatePassword.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "yzm", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "yzm_box inline-block"
  }, [_c('img', {
    attrs: {
      "id": "verifyImg2"
    },
    on: {
      "click": function($event) {
        return _vm.fleshVerify('verifyImg2')
      }
    }
  })]), _vm._v(" "), _c('i', {
    staticClass: "glyphicon icon_reload",
    attrs: {
      "id": "cloudFreshenTwo"
    },
    on: {
      "click": function($event) {
        return _vm.fleshVerify('verifyImg2')
      }
    }
  })]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('p', {
    staticClass: "login_btn_box text-center"
  }, [_c('a', {
    staticClass: "btn btn_h btn_issue",
    attrs: {
      "href": "javascript:void(0);",
      "id": "cloudForgetPwd"
    },
    on: {
      "click": function($event) {
        return _vm.updatePassword()
      }
    }
  }, [_vm._v("确定")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "switchover_btn text-center h4 switchover_btn2",
    attrs: {
      "id": "cloudForgetTwo"
    },
    on: {
      "click": function($event) {
        return _vm.fleshVerify('verifyImg2')
      }
    }
  }, [_vm._v("\n        忘记密码\n      ")])])]), _vm._v(" "), _c('section', {
    staticClass: "register_box switchover login_box_3"
  }, [_c('div', {
    staticClass: "box_info"
  }, [_c('div', {
    staticClass: "register_box_info"
  }, [_c('h5', {
    staticClass: "h4 login_title"
  }, [_vm._v("注册新账号")]), _vm._v(" "), _c('router-view')], 1), _vm._v(" "), _c('div', {
    staticClass: "switchover_btn text-center h4",
    attrs: {
      "id": "cloudRegister"
    },
    on: {
      "click": function($event) {
        return _vm.fleshVerify('verifyImg1')
      }
    }
  }, [_vm._v("\n        注册\n      ")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tip_box vis-hide denglu"
  }, [_c('small', {
    staticClass: "tip_yz"
  }, [_vm._v("密码错误！")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tip_box "
  }, [_c('small', {
    staticClass: "tip_yz"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-ab032fe8"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/loginGroup/login_index.vue
// module id = 1278
// module chunks = 1